<template>
  <div>
    <div class="section1">
      <div class="s1-title">{{ dataRow.title }}</div>
      <div class="s1-content">
        <!-- <div>
          <img src="../image/details/list10.jpg" />
          <span>&nbsp;{{ dataRow.addTime }}</span>
        </div> -->
        <div class="s1-number">
          <img src="../image/details/list11.jpg" />
          <span>&nbsp;{{ dataRow.browse }}</span>
        </div>
        <div class="s1-author">
          <span>作者：{{ dataRow.username }}</span>
          <span v-if="dataRow.source">&nbsp;来源：{{ dataRow.source }}</span>
        </div>
      </div>
    </div>
    <div class="section2">
      <!-- <div class="s2-1"><img :src="dataRow.img" class="s2-img" /></div> -->
      <div
        v-html="dataRow.content"
        :class="[$route.query.name == '政协概况' ? 's2-texts' : 's2-text']"
      ></div>

      <div v-if="dataRow.pdfName && fileList.length">
        <p v-for="(item, index) in fileList" :key="index">
          <a class="fj" target="_blank" :href="item.url">
            {{item.name}}
          </a>
        </p>
      </div>
    </div>

    <div class="section3">
      <div @click="goDetails1(previous)" v-if="previous">
        上一篇：<a>{{ previous.title }}</a>
      </div>
      <div @click="goDetails1(next)" v-if="next">
        下一篇：<a>{{ next.title }}</a>
      </div>
    </div>
    <!-- <div class="section4">
      <div class="s4-title">相关推荐</div>
      <div class="s4-imglist" style="transform: translateX()">
        <div class="s4-imglist-1" v-for="(item, index) in imgList" :key="index">
          <img :src="item.src" class="s4-img" />
          <div class="s4-text">{{ item.text }}</div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import lib from '../api';
export default {
  props: {
    id: Number,
  },
  data() {
    return {
      fileList: [],
      previous: {},
      next: {},
      defaultImg:
        'this.src="' + require('../../static/image/home/img1.jpg') + '"',
      timer: '',
      dataTime: this.$route.query.item,
      dataRow: {},
      imgList: [
        {
          src: 'static/image/home/swiper1.jpg',
          text: '守好百姓“救命钱” 市政协视察我市医保反欺诈工作情况',
        },
        {
          src: 'static/image/home/swiper2.jpg',
          text: '第二期徐州政协讲坛开讲',
        },
        {
          src: 'static/image/home/swiper3.jpg',
          text: '省政协教卫体委来徐调研',
        },
        {
          src: 'static/image/home/swiper4.jpg',
          text: '全市政协港澳台侨和外事工作座谈会召开',
        },
      ],
    };
  },
  methods: {
    goDetails1(item) {
      if (item.link == null || item.link == '') {
        this.$router
          .push({
            path: '/pageDetails',
            query: {
              id: item.id,
              names: '详情',
            },
          })
          .catch((r) => r);
        location.reload();
      } else {
        location.href = item.link;
      }
    },
    start() {
      var speed = 0;
      function carousel() {
        speed -= 0.6; //调速率
        if (speed > -1100) {
          $('.goods-list').css({
            transform: 'translateX(' + speed + 'px)',
          });
        } else {
          speed = 0;
        }
      }
    },
  },
  mounted() {
    // this.start();

    lib
      .dataDetail({
        params: {
          id: parseInt(this.$route.query.id),
        },
      })
      .then((r) => {
        if (r.data.pdfName) {
          let file = r.data.pdf.split(',');
          this.fileList = r.data.pdfName
            .split(',')
            .map((i, index) => ({ name: i, url: file[index] }));
          console.log('this.fileList', this.fileList);
        }
        this.previous = r.data.previousPosts;
        this.next = r.data.nextChapter;
        // 后台返回的数据中的图片、视频等宽度改为百分之百
        if (r.data.content !== null) {
          let regex1 = new RegExp('<img', 'gi');
          r.data.content = r.data.content.replace(
            regex1,
            `<img style="max-width: 100%; height: auto"`
          );
          let regex2 = new RegExp('<video', 'gi');
          r.data.content = r.data.content.replace(
            regex2,
            `<video style="max-width: 100%; height: auto"`
          );
          
        }
        
        this.dataRow = r.data;
      });
  },
};
</script>
<style scoped>
/* 轮播动画 */

.section2 img {
  text-align: center;
}
.s4-text {
  width: 96%;
  padding-left: 4%;
  margin-top: 5px;
}
.s4-img {
  width: 100%;
}
.s4-imglist-1 {
  width: 24%;
  height: 100%;
  background-color: #f5f5f5;
  margin-top: 20px;
}
.s4-imglist {
  width: 100%;
  height: 240px;
  /* background-color: indianred; */
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.s4-title {
  width: 99%;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid gainsboro;
  padding-left: 1%;
  font-size: 20px;
  color: #015293;
  font-weight: bolder;
}
.section4 {
  width: 1100px;
  height: 350px;
  margin: auto;
  /* background-color: grey; */
}
.section3 a:hover {
  color: #ed0505;
}
.section3 {
  width: 1100px;
  margin: auto;
  height: 70px;
  margin-top: 40px;
  /* background-color: gainsboro; */
  border-top: 1px solid rgb(238, 237, 237);
  font-size: 18px;
  line-height: 30px;
  padding-top: 10px;
}
.s2-1 {
  width: 100%;
  text-align: center;
}
.s2-text {
  line-height: 35px;
  font-size: 18px;
}
.s2-img {
  margin-top: 20px;
  width: 80%;
}
.section2 {
  width: 1100px;
  /* height: 750px; */
  margin: auto;
  /* background-color: grey; */
  /* border-bottom: 1px solid rgb(238, 237, 237); */
}
.s1-author {
  margin-left: 50px;
}
.s1-number {
  margin-left: 30px;
}
.s1-content {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  /* margin: auto; */
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
  color: rgb(194, 192, 192);
  /* background-color: gold; */
}
.s1-title {
  width: 100%;
  /* height: 60px; */
  text-align: center;
  margin-top: 20px;
  font-size: 30px;
  font-weight: bolder;
}
.section1 {
  width: 1100px;
  margin: auto;
  /* height: 110px; */
  /* background-color: bisque; */
  border-bottom: 1px solid rgb(238, 237, 237);
  margin-top: 30px;
}
</style>
<style lang="scss" scoped>
.section3 {
  > div {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    a {
      width: 90%;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.fj {
  color: #0047cd;
  text-decoration: none;
  margin-top: 15px;
  display: block;
  font-size: 28px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Details.vue